import usersService from '../../services/usersService'
import customerUserRelationshipsService from '../../services/customerUserRelationshipsService'

class CustomerUserRelationshipController {
  deleteCustomerUserRelationship = customerUserRelationshipsService.deleteCustomerUserRelationship
}

export default new CustomerUserRelationshipController()



// WEBPACK FOOTER //
// ../src/controllers/customerUserRelationshipsController/customerUserRelationshipsController.js